<button
  appButton
  name="format"
  shape="round"
  weight="bold"
  location="conversion-format-select-menu-content"
  [analyticsExtra]="mode + '-' + format.slug"
  spacing="full"
  [ngClass]="{
    'bc-primary-bordered constant': active
  }"
  (click)="formatSelected.emit()"
  *ngIf="!linkMode"
>
  {{ format.slug | uppercase }}
</button>

<a
  appButton
  name="format"
  location="conversion-format-select-menu-content"
  [analyticsExtra]="mode + '-' + format.slug"
  shape="round"
  weight="bold"
  spacing="full"
  [ngClass]="{
    'bc-primary-bordered constant': active
  }"
  [routerLink]="[
    '/convert',
    mode === 'to' ? fromFormat?.slug + '-to-' + format.slug : format.slug + (toFormat ? '-to-' + toFormat.slug : '')
  ]"
  *ngIf="linkMode"
>
  {{ format.slug | uppercase }}
</a>
